import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataWarehouse(params) {
	return client.get("api/warehouse/data", {
		params: params,
	});
}

function exportWarehouse(params) {
	return client.get("api/warehouse/export", {
		params: params,
	});
}

function addWarehouse(params) {
	return client.post("api/warehouse/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateWarehouse(params) {
	return client.post("api/warehouse/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteWarehouse(params) {
	return client.post("api/warehouse/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusWarehouse(params) {
	return client.post("api/warehouse/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getDataWarehouseArea() {
	return client.get("api/warehouse-area/data");
}

function addWarehouseArea(params) {
	return client.post("api/warehouse-area/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateWarehouseArea(params) {
	return client.post("api/warehouse-area/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteWarehouseArea(params) {
	return client.post("api/warehouse-area/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusWarehouseArea(params) {
	return client.post("api/warehouse-area/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataWarehouse,
	exportWarehouse,
	addWarehouse,
	updateWarehouse,
	deleteWarehouse,
	statusWarehouse,
	getDataWarehouseArea,
	addWarehouseArea,
	updateWarehouseArea,
	deleteWarehouseArea,
	statusWarehouseArea
};